import { useRouter } from 'vue-router'
import { useCartStore } from '@/stores/cart'

export function useFunnelRouter() {
  const router = useRouter()
  const cartStore = useCartStore()

  function goToPackageSelection() {
    router.push({ name: 'package-search' })
  }

  function goAfterPackageSelection() {
    router.push({ name: 'meeting-room-search' })
  }

  function goToPackageConfiguration() {
    router.push({ name: 'package-configuration' })
  }

  function goToCheckout() {
    router.push({ name: 'checkout' })
  }

  function isAvailVenueSelection() {
    if (!cartStore.cart?.packageId) {
      return false
    }
    return true
  }

  function isAvailPackageConfiguration() {
    if (!cartStore.cart?.packageId || !cartStore.cart.functionRoomId) {
      return false
    }
    return true
  }

  function isAvailCheckout() {
    if (!cartStore.cart?.packageId || !cartStore.cart.functionRoomId) {
      return false
    }
    return true
  }

  return {
    goToPackageSelection,
    goAfterPackageSelection,
    goToPackageConfiguration,
    goToCheckout,

    isAvailVenueSelection,
    isAvailPackageConfiguration,
    isAvailCheckout,
  }
}
